import type { ReactNode } from 'react'

import { Container, type ContainerProps } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { StylesHelper } from '../helpers/Styles.helper'

type TSAContainerProps = {
  children: ReactNode | ReactNode[]
} & ContainerProps
export const TSAContainer = ({ children, ...props }: TSAContainerProps) => {
  const desktopScreen = useMediaQuery('(min-width: 1550px)')

  return (
    <Container maw={desktopScreen ? '90vw' : undefined} {...props}>
      {children}
    </Container>
  )
}
